import { User, Home } from "lucide-react";

export default function Header() {
  return (
    <header className="w-full bg-[#006DB7] text-white py-4 px-32 flex justify-between items-center">
      <div>
    <img src="/logo.png" className="h-12" />
      </div>
      <div className="flex space-x-4">
        <User className="w-6 h-6" />
        <Home className="w-6 h-6" />
      </div>
    </header>
  );
}
